import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { processSteps, proposalChecklist } from '../../data/process';
import { Button } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
import { SectionHeader } from '../ui/SectionHeader';
export function Process() {
  return <section id="process" aria-labelledby="process-title" className="bg-afb-light" data-id="element-423" data-mp="k35g10qs5wtw">
      <div className="mx-auto max-w-page px-5 py-20 lg:px-8 lg:py-28" data-id="element-424" data-mp="3sj7916dboblm">
        <Reveal data-id="element-425" data-mp="3she0tmn29jbi">
          <SectionHeader id="process-title" title="What happens after you get in touch" intro="Five steps from first conversation to a running system, with no surprises in between." data-id="element-426" data-mp="3nkdurbq7ogke" />
        </Reveal>

        <div className="mt-14 grid gap-12 lg:grid-cols-[1.2fr_0.8fr] lg:gap-16" data-id="element-427" data-mp="1cdwx7gzqs2b">
          <ol className="relative" data-id="element-428" data-mp="39s7ezqqz0blh">
            <span aria-hidden="true" className="absolute bottom-6 left-[19px] top-6 w-px bg-afb-ink/15" data-id="element-429" data-mp="39r4ohjxk8b63" />
            {processSteps.map((step, index) => <li key={step.title} className="relative flex gap-6 pb-10 last:pb-0" data-id="element-430" data-mp="2msbmba67hdah" data-mpi={index}>
                <Reveal delay={index * 50} className="flex gap-6" data-id="element-431" data-mp="2rqn0ty7g4bz1">
                  <span className="relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-afb-ink/15 bg-white font-sora text-sm font-semibold text-afb-ink" data-id="element-432" data-mp="2rosau5hbhto3">
                    {index + 1}
                  </span>
                  <div className="pt-1.5" data-id="element-433" data-mp="23tpp46dt86bu">
                    <h3 className="font-sora text-lg font-semibold" data-id="element-434" data-mp="23v0rc1rlx60u">{step.title}</h3>
                    <p className="mt-1.5 max-w-md text-[15px] leading-relaxed text-afb-muted" data-id="element-435" data-mp="28skczmqmwl2t">{step.detail}</p>
                  </div>
                </Reveal>
              </li>)}
          </ol>

          <Reveal delay={80} data-id="element-436" data-mp="2hu0grbmy1oy2">
            <aside className="rounded-card bg-afb-ink p-6 text-white md:p-8 lg:sticky lg:top-28" data-id="element-437" data-mp="3o8sz1n80uxse">
              <h3 className="font-sora text-xl font-semibold" data-id="element-438" data-mp="3t7vt6cmgrjll">Bring these to your first call</h3>
              <ul className="mt-6 space-y-3" data-id="element-439" data-mp="1t5mhmkjvr90j">
                {proposalChecklist.map(item => <li key={item} className="flex items-start gap-3 text-[15px] text-white/85" data-id="element-440" data-mp="1p419tdm7dkx7">
                    <CheckIcon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-afb-turquoise" data-id="element-441" data-mp="233sj511ryd4v" />
                    {item}
                  </li>)}
              </ul>
              <p className="mt-6 text-sm leading-relaxed text-white/60" data-id="element-442" data-mp="1y2wicwcpz73o">
                Don’t have all of it? That’s normal. We work out the gaps with you during discovery.
              </p>
              <Button href="#contact" className="mt-8 w-full" data-id="element-443" data-mp="15dz20ys2jkdk">
                Request a demo / site assessment
                <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-444" data-mp="1fe7z0etvx9u0" />
              </Button>
            </aside>
          </Reveal>
        </div>
      </div>
    </section>;
}